module.exports = __webpack_public_path__ + "images/iconPlus-4644a6.svg";